import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { NullActionTypes } from 'generated/graphql-types';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { extensionOptionSelectors } from '../state/extension-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: ExtensionSelectComponent,
        },
    ],
    selector: 'ndt-extension-select',
    templateUrl: './extension-select.component.html',
    standalone: false
})
export class ExtensionSelectComponent extends LcsSingleSelectBase<ExtensionOption> implements OnInit {
   @Input() extensionsToExclude: ExtensionOption[] = [];

   @Input() nullActionsToInclude: NullActionTypes[] = [];

   extensions: Observable<ExtensionOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      const extensions$ = this.store.pipe(select(extensionOptionSelectors.selectFilteredItems), this.itemsLoaded());
      const searchTerm$ = this.store.pipe(select(extensionOptionSelectors.selectSearchTerm));

      this.extensions = combineLatest([extensions$, searchTerm$]).pipe(
         map(([results, searchTerm]) => {
            const normalizedSearch = searchTerm?.toLowerCase()?.trim() ?? '';

            let filteredResults = results.filter(
               (ext) => !this.extensionsToExclude.find((x) => x.extensionId === ext.extensionId)
            );
            const additionalOptions: ExtensionOption[] = [];
            if (this.nullActionsToInclude?.includes(NullActionTypes.Directory)) {
               additionalOptions.push({ extensionId: -1, number: -1, name: 'Name Directory' });
            }
            if (this.nullActionsToInclude?.includes(NullActionTypes.Hangup)) {
               additionalOptions.push({ extensionId: -2, number: -2, name: 'Hangup' });
            }
            if (this.nullActionsToInclude?.includes(NullActionTypes.Voicemail)) {
               additionalOptions.push({ extensionId: -3, number: -3, name: 'Voicemail' });
            }
            const filteredAdditionalOptions = normalizedSearch
               ? additionalOptions.filter((opt) => opt.name?.toLowerCase().includes(normalizedSearch))
               : additionalOptions;

            return [...filteredAdditionalOptions, ...filteredResults];
         })
      );
   }

   displayWith(item: ExtensionOption | null): string | null {
      if (!item || !item.number) return null;
      return item.number >= 0 ? `${item.number} - ${item.name}` : item.name;
   }

   trackBy(item: ExtensionOption | null) {
      return item ? item.extensionId : null;
   }
}
